import { useSelector } from 'react-redux';
import { useAllJobTypesData } from './selectors';
import { Snackbar, snackbarSelector } from './slices/snackbar';
import { RootState } from './store';

export const useJobTypeData = (jobTypeId: string) => {
  const jobTypesData = useAllJobTypesData();
  return jobTypesData?.find(item => item.id === jobTypeId);
};

export const useSnackbarState = () =>
  useSelector<RootState, Snackbar>(snackbarSelector);
